module.exports = __webpack_public_path__ + "img/SB_20.f1082c53.png";